module.exports = __webpack_public_path__ + "img/link.0664766f.svg";